import React from "react";
import ReactPaginate from "react-paginate";
import Icon from "components/AppIcon";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="mt-8 bg-surface border border-border rounded-lg p-6">
      <div className="flex justify-center">
        <ReactPaginate
          previousLabel={
            <div className="flex items-center space-x-1">
              <Icon name="ChevronLeft" size={16} />
              <span className="hidden sm:inline">Previous</span>
            </div>
          }
          nextLabel={
            <div className="flex items-center space-x-1">
              <span className="hidden sm:inline">Next</span>
              <Icon name="ChevronRight" size={16} />
            </div>
          }
          breakLabel="..."
          pageCount={totalPages}
          marginPagesDisplayed={1}
          pageRangeDisplayed={3}
          onPageChange={onPageChange}
          forcePage={currentPage}
          containerClassName="flex items-center space-x-1"
          pageClassName="hidden sm:block"
          pageLinkClassName="px-3 py-2 text-sm font-medium text-text-primary bg-surface border border-border rounded-md hover:bg-primary hover:text-white transition-colors duration-200"
          previousClassName="flex"
          previousLinkClassName="px-3 py-2 text-sm font-medium text-text-primary bg-surface border border-border rounded-md hover:bg-primary hover:text-white transition-colors duration-200"
          nextClassName="flex"
          nextLinkClassName="px-3 py-2 text-sm font-medium text-text-primary bg-surface border border-border rounded-md hover:bg-primary hover:text-white transition-colors duration-200"
          breakClassName="hidden sm:block"
          breakLinkClassName="px-3 py-2 text-sm font-medium text-text-secondary"
          activeClassName="bg-primary border-primary"
          activeLinkClassName="!text-white !bg-primary !border-primary"
          disabledClassName="opacity-50 cursor-not-allowed"
          disabledLinkClassName="!cursor-not-allowed hover:!bg-surface hover:!text-text-primary"
        />
      </div>
    </div>
  );
};

export default Pagination;
